import AbstractNotifier from '@/utils/Services/Agent/Notifiers/AbstractNotifier';
import JonviewNotifyPolicy from "@/policies/Proposal/Product/ProductPolicy/JonviewNotifyPolicy";

export default class JonviewNotifier extends AbstractNotifier {
    get title() {
        return 'Jonview notify';
    }

    get notificationTitle() {
        return 'Notificatie via Jonview API';
    }

    proposalProductPolicy() {
        return JonviewNotifyPolicy;
    }

    canImportProduct() {
        return true;
    }
}
